// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Swatches-module--wrapper--3mcCn","swatch":"Swatches-module--swatch--3Kwqz","active":"Swatches-module--active--22R91"};